import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SwitchAccessShortcutAddIcon from "@mui/icons-material/SwitchAccessShortcutAdd";
import { Box } from "@mui/material";
import {
  ListRequestOfBaseFilter,
  UserModel,
} from "services/organizationPortalClient";
import { UserStatusType } from "types/userStatusTypes";
import { FormattedMessage as T } from "react-intl";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useQuery } from "react-query";
import useGlobalContext from "hooks/globalData";
import contextStore from "stores/contextStore";

type UserThreeDotsMenuProps = {
  user: UserModel;
  deactivate: (organizationUserId: string) => void;
  resendInvite: (organizationUserId: string) => void;
  reactivate: (organizationUserId: string) => void;
  changeAccessLevel: (organizationUser: UserModel) => void;
};

export default function UserThreeDotsMenu({
  user,
  deactivate,
  reactivate,
  resendInvite,
  changeAccessLevel,
}: UserThreeDotsMenuProps) {
  const { organizationUserService } = useGlobalContext();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { organization } = contextStore.useState();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const showResendInvite = user.statusTypeName === UserStatusType.Pending;
  const showDeactivate =
    user.statusTypeName === UserStatusType.Active ||
    user.statusTypeName === UserStatusType.Pending;

  const showReactivate = user.statusTypeName === UserStatusType.Inactive;

  const { data: accessLevelsData } = useQuery(
    ["organization-user-access-levels", organization?.id],
    () =>
      organizationUserService.getAccessLevels(
        ListRequestOfBaseFilter.fromJS({ sortField: "sequence" })
      )
  );

  return (
    <Box>
      <IconButton
        aria-controls={open ? "three-dots-context-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="three-dots-context-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
      >
        {showResendInvite && (
          <MenuItem dense onClick={() => resendInvite(user.id)}>
            <MailOutlineIcon sx={{ mr: 1 }} />
            <T id="resendInvite" />
          </MenuItem>
        )}
        {(accessLevelsData?.data?.length ?? 0) > 1 && (
          <MenuItem dense onClick={() => changeAccessLevel(user)}>
            <SwitchAccessShortcutAddIcon sx={{ mr: 1 }} />
            <T id="changeAccessLevel" />
          </MenuItem>
        )}
        {showDeactivate && (
          <MenuItem dense onClick={() => deactivate(user.id)}>
            <RemoveCircleOutlineIcon sx={{ mr: 1 }} />
            <T id="deactivate" />
          </MenuItem>
        )}
        {showReactivate && (
          <MenuItem dense onClick={() => reactivate(user.id)}>
            <AddCircleOutlineIcon sx={{ mr: 1 }} />
            <T id="reactivate" />
          </MenuItem>
        )}
      </Menu>
    </Box>
  );
}
